import { render, staticRenderFns } from "./SpecimenInfoTab.vue?vue&type=template&id=3246100a&scoped=true"
import script from "./SpecimenInfoTab.vue?vue&type=script&lang=js"
export * from "./SpecimenInfoTab.vue?vue&type=script&lang=js"
import style0 from "./SpecimenInfoTab.vue?vue&type=style&index=0&id=3246100a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246100a",
  null
  
)

export default component.exports